module.exports = __webpack_public_path__ + "img/ledger-city-dev-diary.daf511d6.png";